// extracted by mini-css-extract-plugin
export default {"justify-navbar":"NavbarCustomer_justify-navbar__Gi6qI","list-notification":"NavbarCustomer_list-notification__0buO8"};